module.exports = __webpack_public_path__ + "r-v3/img/emoti-satisfaction.9f2d8ca2.svg";